(function () {
  'use strict';

  var TOPICS = ['design', 'trouble', 'size', 'price', 'proof', 'timing', 'rush', 'shipping', 'outdoor', 'colors', 'power', 'install', 'bulk', 'warranty', 'returns', 'damage', 'artwork', 'tracking', 'battery', 'payment'];
  var PRIMARY = ['design', 'price', 'timing', 'shipping'];
  var LINKS = {
    design: '/pages/neon-customizer', trouble: '/pages/upload-neon-sign', size: '/pages/upload-neon-sign',
    price: '/pages/neon-customizer', proof: '/pages/upload-neon-sign', timing: '/pages/upload-neon-sign',
    rush: '/pages/upload-neon-sign', shipping: '/pages/upload-neon-sign', outdoor: '/pages/neon-customizer',
    colors: '/pages/neon-customizer', power: '/pages/setup-guides', install: '/pages/setup-guides',
    bulk: '/pages/wholesale', warranty: '/policies/refund-policy', returns: '/policies/refund-policy',
    damage: '/policies/refund-policy', artwork: 'mailto:miamineons305@gmail.com',
    battery: '/pages/upload-neon-sign', payment: '/cart'
  };
  var RULES = {
    trouble: [[8, /\b(?:not working|doesnt work|wont work|cannot checkout|cant checkout|cant check out|cannot check out|wont add|cant add|cannot add|button broken|error|stuck|bug|blank preview|checkout problem|payment failed|cart problem)\b/], [5, /\b(?:checkout|customizer|designer|cart|upload|preview|button)\b.*\b(?:broken|fails|failing|problem|issue|help|cant|cannot|wont|does nothing|nothing happens)\b/], [5, /\b(?:cant|cannot|wont|help|problem|issue|nothing happens)\b.*\b(?:checkout|customizer|designer|cart|upload|preview|button)\b/]],
    size: [[7, /\b(?:how big|how large|what size|which size|size options|custom size|too big|larger than|bigger than|over 60|more than 60)\b/], [4, /\b(?:sizes?|dimensions?|width|height|inches|oversized|measurements?|feet|ft)\b/]],
    price: [[7, /\b(?:how much|what does it cost|what is the price|cost of|price of|pricing)\b/], [4, /\b(?:prices?|costs?|budget|expensive|affordable|cheaper|quote|estimate)\b/]],
    proof: [[8, /\b(?:free proof|free design|free quote|design proof|see it first|see it before|see before|mockup|mock up|sample design)\b/], [5, /\b(?:proof|rendering|render|preview before)\b/]],
    timing: [[8, /\b(?:how long|lead time|turnaround|turn around|production time|processing time|when will it arrive|delivery time|how soon|when can i get|when would it arrive)\b/], [4, /\b(?:production|processing|timeline|timing)\b/]],
    rush: [[10, /\b(?:rush|urgent|urgently|asap|tomorrow|today|next day|same day|next week|this week|last minute|expedited|expedite|in a week|in one week|under two weeks|under 2 weeks|less than two weeks|less than 2 weeks|within a week)\b/], [8, /\b(?:need|needed|ready|deliver|arrive|get it).{0,35}\b(?:[1-9]|1[0-3])\s*(?:day|days)\b/], [8, /\b(?:this|next|by)\s+(?:monday|tuesday|wednesday|thursday|friday|saturday|sunday|weekend)\b/], [4, /\b(?:deadline|event date|needed by|event on|event next|event this)\b/]],
    shipping: [[9, /\b(?:shipping cost|cost of shipping|free shipping|ship to|shipping to|do you ship|delivery cost|international shipping|ship internationally|deliver there|deliver to|shipping price)\b|\bhow much\b.{0,25}\b(?:shipping|delivery|ship)\b/], [5, /\b(?:shipping|freight|ship|delivery|transit|alaska|hawaii|international|continental|nationwide|canada)\b/]],
    outdoor: [[8, /\b(?:outdoors?|waterproof|weatherproof|rain|weather|outside|wet|water resistant)\b/]],
    colors: [[8, /\b(?:color changing|colour changing|color change|colour change|color fade|chasing colors|chasing colours|rgb|multicolor|multi color)\b/], [4, /\b(?:colou?rs?|chasing|fade|fading)\b/]],
    power: [[7, /\b(?:power supply|what is included|whats included|comes with|come with|in the box|plug in|plug it in|power adapter)\b/], [4, /\b(?:power|adapter|outlet|electricity|voltage|dimmer|remote|controller|accessories|cord|cable)\b/]],
    install: [[8, /\b(?:how to hang|how do i hang|how to install|how do i install|mounting|installation|wall mount|hang it|hang my)\b/], [5, /\b(?:mount|install|standoffs?|fixings?|hardware|screws?|fasten|drywall)\b/]],
    bulk: [[9, /\b(?:wholesale|bulk|multiple locations|multi location|multiple signs|several signs|many signs|quantity discount|franchise)\b/], [6, /\b(?:[2-9]|[1-9][0-9]+|two|three|four|five|six|seven|eight|nine|ten)\s+(?:signs|neons)\b/]],
    warranty: [[10, /\b(?:warranty|warranties|product guarantee|stopped working|stopped lighting|no longer works|no longer working|flicker|flickering|repair|defect|defective)\b/], [10, /\b(?:my sign|the sign|our sign)\b.{0,25}\b(?:not working|doesnt work|does not work|wont turn on|isnt turning on|doesnt light|not lighting|wont light)\b/]],
    returns: [[10, /\b(?:return|returns|refund|refundable|cancel|cancellation|cancelled|canceled|money back)\b/]],
    damage: [[12, /\b(?:damaged|arrived broken|broken on arrival|broke in shipping|shipping damage|cracked|delivery damage|arrived damaged)\b/]],
    artwork: [[10, /\b(?:approve|approval|approvals|revision|revisions|spelling|typo|edit my|change my|change the|revise|approved proof)\b/], [6, /\b(?:artwork email|email artwork|email my logo|email my design|send artwork|send my artwork)\b/]],
    tracking: [[12, /\b(?:order status|track my|tracking|where is my|wheres my|my order|order number|already ordered|has it shipped|has my|did it ship|haven t received|havent received|not arrived|late order)\b/]],
    battery: [[12, /\b(?:batteries|battery|battery powered|cordless|portable|rechargeable)\b/]],
    payment: [[7, /\b(?:how do i pay|how to pay|payment methods|pay online|payment link|pay an invoice|pay the invoice|credit card|debit card|deposit|partial payment|installments|instalments)\b/], [4, /\b(?:payment|payments|pay|invoice|checkout)\b/]],
    design: [[7, /\b(?:how do i order|how to order|start a design|how to use|how do i use|make my own|create my own|upload my logo|upload a logo|business logo|custom logo|custom design)\b/], [4, /\b(?:customizer|customise|customize|designer|design|logo|text|font|artwork|upload|personalized|personalised)\b/]]
  };

  function normalize(text) {
    return String(text || '').toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '').replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim().replace(/\b(?:shiping|shippng)\b/g, 'shipping').replace(/\b(?:warrenty|waranty)\b/g, 'warranty').replace(/\b(?:custumizer|customiser)\b/g, 'customizer');
  }

  function classify(text, previousIntent) {
    var input = normalize(text).slice(0, 600);
    if (!input) return {intent: 'empty', score: 0};
    var negatedHuman = /\b(?:dont|do not|no need to|not wanting to|not want to|rather not|without)\s+(?:want to\s+|need to\s+)?(?:call|speak|talk|phone|contact)\b|\b(?:no human|no agent|dont need (?:a )?(?:person|human|agent)|dont want (?:a )?(?:person|human|agent))\b/.test(input);
    var human = /\b(?:human|agent|representative|real person|someone real|customer service|customer support|phone number|telephone|call you|call us|call me|call someone|call the|call your|give me a call|talk to|speak to|speak with|talk with|contact someone|contact the team|contact your team|number to call|put me through|connect me to)\b/.test(input) || /^(?:call|phone|person|help from a person|team|contact)$/.test(input);
    var unresolved = /\b(?:not helpful|didnt help|doesnt help|does not help|still need help|still dont|still not|not what i|not what im|doesnt answer|didnt answer|does not answer|no help|not answered|does not resolve|didnt resolve|doesnt resolve|not resolved)\b/.test(input);
    if ((human && !negatedHuman) || unresolved || (previousIntent && /^(?:no|nope|not really|not yet)$/.test(input))) return {intent: 'human', score: 100};
    if (/^(?:hi|hello|hey|hey there|hi there|good morning|good afternoon|good evening)[!. ]*$/.test(input)) return {intent: 'greeting', score: 100};
    if (/^(?:yes|yep|yeah|thanks|thank you|yes thanks|yes thank you|thank you so much|that helped|that helps|perfect|great|all good|got it|ok|okay)$/.test(input)) return {intent: 'thanks', score: 100};
    if (/^(?:help|help me|more|more questions|another question|ask another|topics|faq|faqs)$/.test(input)) return {intent: 'menu', score: 100};
    if (/\b(?:hours|opening|closing|open today|open now|business hours|address|location|pickup|pick up|tax|taxes|coupon|promo code|discount code|discounts?|coupon code|exchange rate)\b/.test(input) && !/\b(?:bulk|wholesale|multiple locations|quantity discount)\b/.test(input)) return {intent: 'unknown', score: 0};
    var ranked = Object.keys(RULES).map(function (intent) {
      return {intent: intent, score: RULES[intent].reduce(function (total, rule) {return total + (rule[1].test(input) ? rule[0] : 0);}, 0)};
    }).sort(function (a, b) {return b.score - a.score;});
    if (ranked[0].score < 4) return {intent: negatedHuman ? 'menu' : 'unknown', score: 0};
    if (ranked[0].intent === 'tracking') {
      var action = ['damage', 'returns', 'artwork', 'warranty'].map(function (intent) {return ranked.find(function (r) {return r.intent === intent;});}).find(function (r) {return r.score >= 10;});
      if (action) return action;
    }
    if (ranked[0].intent === 'price' && ranked.some(function (r) {return r.intent === 'shipping' && r.score >= 9;})) return {intent: 'shipping', score: 20};
    if (ranked[0].intent === 'trouble' && ranked.some(function (r) {return r.intent === 'warranty' && r.score >= 10;}) && !/\b(?:customizer|checkout|preview|cart|website|upload|button)\b/.test(input)) return {intent: 'warranty', score: 20};
    return ranked[0];
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {classify: classify, normalize: normalize, topics: TOPICS.slice()};
  if (typeof document === 'undefined') return;

  function init() {
    var root = document.querySelector('[data-mn-faq-root]');
    var source = document.querySelector('[data-mn-faq-config]');
    if (!root || !source || root.dataset.mnFaqReady) return;
    var cfg;
    try { cfg = JSON.parse(source.textContent); } catch (_) { return; }
    if (!cfg.ui || !cfg.answers) return;
    root.dataset.mnFaqReady = 'true';
    var studio = document.querySelector('[data-mn-customizer="universal"]');
    if (studio && studio.parentNode) {
      root.classList.add('mn-faq-in-studio');
      studio.parentNode.insertBefore(root, studio);
    }
    var ui = cfg.ui;
    var open = false;
    var previousIntent = null;
    var feedback = null;
    var savedFocus = null;
    var frame = 0;

    function el(tag, className, text) {
      var item = document.createElement(tag);
      if (className) item.className = className;
      if (text !== undefined) item.textContent = text;
      return item;
    }

    function button(label, className, action) {
      var item = el('button', className, label);
      item.type = 'button';
      item.addEventListener('click', action);
      return item;
    }

    function icon(kind) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('width', '22');
      svg.setAttribute('height', '22');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '1.8');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', kind === 'close' ? 'M6 6l12 12M18 6L6 18' : kind === 'send' ? 'M5 12h14M13 6l6 6-6 6' : 'M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5');
      svg.appendChild(path);
      return svg;
    }

    var launcher = button('', 'mn-faq-launcher', function () {setOpen(!open);});
    launcher.appendChild(icon('chat'));
    launcher.appendChild(el('span', 'mn-faq-launcher-label', ui.launcher));
    launcher.setAttribute('aria-label', ui.open);
    launcher.setAttribute('aria-expanded', 'false');
    launcher.setAttribute('aria-controls', 'mn-faq-panel');
    launcher.setAttribute('aria-haspopup', 'dialog');
    var panel = el('section', 'mn-faq-panel');
    panel.id = 'mn-faq-panel';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-labelledby', 'mn-faq-title');
    var header = el('header', 'mn-faq-header');
    var mark = el('span', 'mn-faq-mark');
    mark.appendChild(icon('chat'));
    var heading = el('div', 'mn-faq-heading');
    var title = el('h2', 'mn-faq-title', ui.title);
    title.id = 'mn-faq-title';
    heading.appendChild(title);
    heading.appendChild(el('p', 'mn-faq-subtitle', ui.subtitle));
    var close = button('', 'mn-faq-close', function () {setOpen(false);});
    close.setAttribute('aria-label', ui.close);
    close.appendChild(icon('close'));
    header.append(mark, heading, close);
    var feed = el('div', 'mn-faq-feed');
    feed.setAttribute('role', 'log');
    feed.setAttribute('aria-live', 'polite');
    feed.setAttribute('aria-relevant', 'additions');
    feed.setAttribute('aria-label', ui.conversation);
    feed.setAttribute('tabindex', '0');
    var composer = el('form', 'mn-faq-form');
    var label = el('label', 'mn-faq-sr-only', ui.input_label);
    label.setAttribute('for', 'mn-faq-input');
    var input = el('input', 'mn-faq-input');
    input.id = 'mn-faq-input';
    input.type = 'text';
    input.name = 'mn_faq_question';
    input.placeholder = ui.placeholder;
    input.maxLength = 600;
    input.autocomplete = 'off';
    input.setAttribute('enterkeyhint', 'send');
    var send = el('button', 'mn-faq-send');
    send.type = 'submit';
    send.setAttribute('aria-label', ui.send);
    send.appendChild(icon('send'));
    composer.append(label, input, send);
    composer.addEventListener('submit', function (event) {
      event.preventDefault();
      var question = input.value.trim().slice(0, 600);
      if (!question) return;
      input.value = '';
      userMessage(question);
      respond(classify(question, previousIntent).intent);
    });
    var footer = el('div', 'mn-faq-footer');
    footer.appendChild(el('span', 'mn-faq-privacy', ui.privacy));
    footer.appendChild(button(ui.clear, 'mn-faq-clear', function () {reset(); input.focus({preventScroll: true});}));
    panel.append(header, feed, composer, footer);
    root.append(panel, launcher);

    function jumpToLatest() {
      requestAnimationFrame(function () {feed.scrollTop = feed.scrollHeight;});
    }

    function removeFeedback() {
      if (feedback) {feedback.remove(); feedback = null;}
    }

    function message(text, user) {
      var row = el('div', user ? 'mn-faq-message mn-faq-message-user' : 'mn-faq-message mn-faq-message-bot');
      var prefix = el('span', 'mn-faq-sr-only', user ? ui.you : ui.assistant);
      var body = el('p', 'mn-faq-message-text', text);
      row.append(prefix, body);
      feed.appendChild(row);
      while (feed.children.length > 60) feed.firstElementChild.remove();
      jumpToLatest();
      return row;
    }

    function userMessage(text) {
      removeFeedback();
      message(text, true);
    }

    function actionLink(row, label, href, primary) {
      if (!label || !href || !(/^(?:\/pages\/|\/policies\/|\/cart$|tel:\+13055191166$|mailto:miamineons305@gmail\.com$)/.test(href))) return;
      var link = el('a', primary ? 'mn-faq-link mn-faq-link-primary' : 'mn-faq-link', label);
      link.href = href;
      if (studio && /^(?:\/pages\/(?:upload-neon-sign|wholesale|setup-guides)|\/policies\/)/.test(href)) {
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', label + ' ' + ui.new_tab);
      }
      row.appendChild(link);
    }

    function phoneHandoff(includeLead) {
      var row = message(includeLead ? ui.handoff : ui.phone_note, false);
      actionLink(row, ui.call, 'tel:+13055191166', true);
      return row;
    }

    function topicMenu(all) {
      var box = el('div', 'mn-faq-topics');
      box.setAttribute('role', 'group');
      box.setAttribute('aria-label', ui.topics_label);
      (all ? TOPICS : PRIMARY).forEach(function (topic) {
        var answer = cfg.answers[topic];
        if (!answer) return;
        box.appendChild(button(answer.title, 'mn-faq-topic', function () {userMessage(answer.title); respond(topic);}));
      });
      if (!all) box.appendChild(button(ui.more, 'mn-faq-topic mn-faq-topic-more', function () {removeFeedback(); topicMenu(true);}));
      box.appendChild(button(ui.talk, 'mn-faq-topic mn-faq-topic-contact', function () {userMessage(ui.talk); respond('human');}));
      feed.appendChild(box);
      jumpToLatest();
    }

    function helpful() {
      removeFeedback();
      feedback = el('div', 'mn-faq-feedback');
      feedback.appendChild(el('p', 'mn-faq-feedback-title', ui.helpful));
      var choices = el('div', 'mn-faq-feedback-options');
      choices.appendChild(button(ui.yes, 'mn-faq-choice', function () {userMessage(ui.yes); respond('thanks');}));
      choices.appendChild(button(ui.another, 'mn-faq-choice', function () {removeFeedback(); message(ui.ask_another, false); topicMenu(false); input.focus({preventScroll: true});}));
      choices.appendChild(button(ui.talk, 'mn-faq-choice mn-faq-choice-contact', function () {userMessage(ui.talk); respond('human');}));
      feedback.appendChild(choices);
      feed.appendChild(feedback);
      jumpToLatest();
    }

    function respond(intent) {
      removeFeedback();
      if (intent === 'empty') return;
      if (intent === 'greeting' || intent === 'menu') {message(intent === 'greeting' ? ui.greeting : ui.choose_topic, false); topicMenu(intent === 'menu'); return;}
      if (intent === 'thanks') {message(ui.thanks, false); previousIntent = null; return;}
      if (intent === 'human') {phoneHandoff(true); previousIntent = 'human'; return;}
      if (intent === 'unknown' || !cfg.answers[intent]) {
        message(ui.unknown, false);
        phoneHandoff(true);
        topicMenu(false);
        previousIntent = 'unknown';
        return;
      }
      var answer = cfg.answers[intent];
      var row = message(answer.body, false);
      actionLink(row, answer.action, LINKS[intent], false);
      if (['tracking', 'damage', 'returns', 'trouble'].indexOf(intent) !== -1) actionLink(row, ui.call, 'tel:+13055191166', true);
      previousIntent = intent;
      helpful();
    }

    function reset() {
      feed.replaceChildren();
      previousIntent = null;
      feedback = null;
      message(ui.greeting, false);
      topicMenu(false);
    }

    function fitViewport() {
      if (!open) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(function () {
        var viewport = window.visualViewport;
        var height = viewport ? viewport.height : window.innerHeight;
        var offsetTop = viewport ? viewport.offsetTop : 0;
        var bottom = Math.max(0, window.innerHeight - height - offsetTop);
        root.style.setProperty('--mn-faq-viewport-height', Math.round(height) + 'px');
        root.style.setProperty('--mn-faq-keyboard-bottom', Math.round(bottom) + 'px');
      });
    }

    function setOpen(value) {
      open = value;
      panel.hidden = !open;
      root.classList.toggle('mn-faq-is-open', open);
      launcher.setAttribute('aria-expanded', String(open));
      launcher.setAttribute('aria-label', open ? ui.close : ui.open);
      if (open) {
        savedFocus = document.activeElement;
        if (!feed.children.length) reset();
        fitViewport();
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', fitViewport);
          window.visualViewport.addEventListener('scroll', fitViewport);
        }
        window.addEventListener('resize', fitViewport);
        if (window.matchMedia('(min-width: 600px)').matches) input.focus({preventScroll: true});
        else close.focus({preventScroll: true});
        jumpToLatest();
      } else {
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', fitViewport);
          window.visualViewport.removeEventListener('scroll', fitViewport);
        }
        window.removeEventListener('resize', fitViewport);
        cancelAnimationFrame(frame);
        root.style.removeProperty('--mn-faq-viewport-height');
        root.style.removeProperty('--mn-faq-keyboard-bottom');
        if (savedFocus && savedFocus.isConnected) savedFocus.focus({preventScroll: true});
        else launcher.focus({preventScroll: true});
      }
    }

    root.addEventListener('keydown', function (event) {if (event.key === 'Escape' && open) {event.preventDefault(); setOpen(false);}});
    var stylesheet = document.querySelector('[data-mn-faq-style]');
    function reveal() {if (stylesheet) stylesheet.media = 'all'; root.hidden = false;}
    if (!stylesheet || stylesheet.sheet) reveal();
    else stylesheet.addEventListener('load', reveal, {once: true});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();
